import axios from 'axios';

export function getBackendNotifications() {
    return axios({
        method: 'get',
        url: '/api/v1/notification/actual',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getBackendNotification(id) {
    return axios({
        method: 'get',
        url: '/api/v1/notification/actual',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function deleteBackendNotification(id) {
    return axios({
        method: 'delete',
        url: `/api/v1/notification/actual/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateBackendNotification(data) {
    return axios({
        method: 'put',
        url: `/api/v1/notification/actual/${data._id}`,
        withCredentials: true,
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function createBackendNotification(data) {
    return axios({
        method: 'post',
        url: '/api/v1/notification/actual',
        withCredentials: true,
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/backendNotifications.js